import { Button, ButtonProps } from "@chakra-ui/react";
import { useContext } from "react";

import { RanaFormContext } from "../rana-form";

interface RanaFormCancelButtonProps extends ButtonProps {
  extraOnClick?: () => void;
}

export function RanaFormCancelButton({ extraOnClick, ...rest }: RanaFormCancelButtonProps) {
  const { onCancel } = useContext(RanaFormContext);
  return (
    <Button
      onClick={() => {
        onCancel();
        extraOnClick && extraOnClick();
      }}
      variant="secondary"
      {...rest}
    />
  );
}
